import { render, staticRenderFns } from "./EditTeamMemberDialog.vue?vue&type=template&id=45ba5a0d"
import script from "./EditTeamMemberDialog.vue?vue&type=script&lang=js"
export * from "./EditTeamMemberDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports